<template>
  <CockpitDialog
    :title="title"
    right="400px"
    width="1400px"
    height="700px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="w-full h-full flex">
      <iframe class="w-7/10 h-full" :src="iframeUrl" ref="myIframe" @load="centerIframeContent" style="border: none;"></iframe>
      <div class="w-3/10 h-full flex flex-col gap-4" v-if="showVideo">
        <MonitorPlayer
          v-for="(item, index) in monitorList.slice(0, 2)"
          :key="`${item.id}-${index}`"
          :manufacturerCode="item.manufacturerCode"
          :daHuaParams="{
            id: item.id,
            code: item.code,
          }"
          :code="item.code"
          :name="item.name"
          :pIid="item.pIid"
          :showControlPanel="false"
          class="h-1/2"
        />
        <!-- <div
            v-for="item in Math.max(0, 2 - monitorList.length)"
            :key="`empty-${item}`"
            class="h-1/2 w-full text-white flex items-center justify-center border border-solid border-hex-ccc"
          >
            暂无视频
          </div> -->
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const MonitorPlayer = () => {
  return import('./video/MonitorPlayer')
}

export default {
  components: {
    CockpitDialog,
    MonitorPlayer,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    iframeUrl: {
      type: String,
      default: '',
    },
    monitorList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      showVideo: true,
      currentMonitor: {
        code: '',
        name: '',
        pIid: '',
        manufacturerCode: '',
      },
      key: 0,
    }
  },
  watch: {
    monitorList: {
      handler(newVal) {
        this.showVideo = false
        console.log('检测到视频更新', newVal)
        this.key = Date.now()
        setTimeout(() => {
          this.showVideo = true
        }, 200)
      },
      deep: true,
    },
  },
  methods: {
    centerIframeContent() {
      const iframe = this.$refs.myIframe;
      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        const body = doc.body;
        const html = doc.documentElement;
        // 获取内容实际宽度
        const scrollWidth = Math.max(body.scrollWidth, html.scrollWidth);
        // 获取可视区域宽度
        const clientWidth = iframe.clientWidth;
        // 计算要滚动到的位置
        const left = (scrollWidth - clientWidth) / 2;
        // 设置横向滚动条
        iframe.contentWindow.scrollTo(left, 0);
      } catch (e) {
        // 跨域iframe无法操作
        // 可以提示：内容为跨域，无法自动居中
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
